var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('tab-item',{attrs:{"to":{ name: 'admin.reports.commission' }}},[_vm._v(" Commissions Report ")]),_c('tab-item',{attrs:{"to":{ name: 'admin.reports.transaction' }}},[_vm._v(" Merchant Transaction Detail Report ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }